
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientforcedsurat() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warming System in Surat',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warming System in Surat',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Forced Air Warming System in Surat, ensuring optimal temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our forced air warming systems are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Surat to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

   "topPlaces": [
  {
    "title": "Patient Forced Air Warming System in Surat",
    "description": "Pharmacle Health Care Private Limited provides state-of-the-art Patient Forced Air Warming Systems in Surat, designed to prevent perioperative hypothermia and enhance patient comfort in hospitals and surgical centers."
  },
  {
    "title": "Advanced Forced Air Warming System in Surat",
    "description": "Pharmacle Health Care Private Limited offers Advanced Forced Air Warming Systems in Surat, ensuring efficient and uniform heat distribution. Ideal for surgical procedures and post-operative recovery, these systems improve patient safety and outcomes."
  },
  {
    "title": "Portable Patient Warming System in Surat",
    "description": "Lightweight and easy to use, Pharmacle Health Care Private Limited’s Portable Patient Warming System in Surat is perfect for ambulances, emergency rooms, and critical care units, ensuring rapid patient warming during transport and emergencies."
  },
  {
    "title": "Surgical Forced Air Warming Device in Surat",
    "description": "Pharmacle Health Care Private Limited supplies Surgical Forced Air Warming Devices in Surat, specifically designed for operating rooms to maintain normothermia and reduce the risk of intraoperative complications."
  },
  {
    "title": "ICU Patient Forced Air Warming System in Surat",
    "description": "Ideal for intensive care units, Pharmacle Health Care Private Limited’s ICU Patient Forced Air Warming System in Surat provides consistent temperature control, supporting faster recovery for critically ill patients."
  },
  {
    "title": "Neonatal Forced Air Warming System in Surat",
    "description": "Pharmacle Health Care Private Limited delivers specialized Neonatal Forced Air Warming Systems in Surat, ensuring precise and gentle warming for newborns in NICUs and maternity wards."
  },
  {
    "title": "Emergency Forced Air Warming Equipment in Surat",
    "description": "Pharmacle Health Care Private Limited provides Emergency Forced Air Warming Equipment in Surat, a must-have for trauma and critical care. These systems prevent rapid heat loss and stabilize body temperature in emergency situations."
  },
  {
    "title": "Veterinary Forced Air Warming System in Surat",
    "description": "Pharmacle Health Care Private Limited extends its expertise to animal healthcare with Veterinary Forced Air Warming Systems in Surat, offering effective temperature management for pets and livestock during medical treatments and surgeries."
  },
  {
    "title": "Preoperative & Postoperative Forced Air Warming System in Surat",
    "description": "Pharmacle Health Care Private Limited supplies Preoperative and Postoperative Forced Air Warming Systems in Surat, helping patients maintain body warmth before and after surgery, improving recovery times and overall comfort."
  },
  {
    "title": "Disposable Forced Air Warming Blankets in Surat",
    "description": "Pharmacle Health Care Private Limited provides Disposable Forced Air Warming Blankets in Surat. Designed for hygienic, single-use applications, they pair with warming systems to deliver safe, effective, and infection-free patient care."
  }
],


"services": [
    {
        "name": "Patient Forced Air Warming System Surat",
        "description": "Pharmacle Health Care Private Limited offers patient forced air warming systems in Surat, designed to ensure effective temperature regulation during surgeries and critical care. These systems help prevent hypothermia and maintain patient safety throughout medical procedures."
    },
    {
        "name": "Surat Patient Warming Devices",
        "description": "We provide advanced patient warming devices in Surat, designed to regulate body temperature during surgeries, post-operative recovery, and critical care. Our devices help in maintaining patient comfort and safety by preventing temperature-related complications."
    },
    {
        "name": "Surat Forced Air Warming System",
        "description": "Our forced air warming systems in Surat are highly effective in regulating patient body temperature by providing continuous warm air flow. These systems are ideal for use in hospitals and healthcare facilities to ensure optimal thermal comfort for patients."
    },
    {
        "name": "Medical Warming Equipment Surat",
        "description": "Pharmacle Health Care offers medical warming equipment in Surat that provides temperature regulation solutions to maintain optimal patient body temperature during medical procedures, ensuring safety and comfort in critical care and recovery."
    },
    {
        "name": "Patient Thermoregulation Equipment Surat",
        "description": "We supply patient thermoregulation equipment in Surat, designed to regulate and maintain a stable body temperature for patients. These devices are essential in preventing hypothermia and ensuring a safe and controlled environment during surgeries and treatments."
    },
    {
        "name": "Surat Warming Devices for Hospitals",
        "description": "Our warming devices for hospitals in Surat are specifically designed to maintain patient body temperature during medical treatments. These devices are crucial in ensuring that patients remain at a safe, stable temperature throughout their care."
    },
    {
        "name": "Surat Temperature Control Warming Systems",
        "description": "We provide temperature control warming systems in Surat that ensure effective thermal management for patients. These systems are designed to maintain the ideal body temperature during surgeries, critical care, and recovery, preventing hypothermia and promoting patient comfort."
    }
],
"tableData": [
    ["- Patient Forced Air Warming System Surat", "- Surat Patient Warming Devices"],
    ["- Surat Forced Air Warming System", "- Medical Warming Equipment Surat"],
    ["- Patient Thermoregulation Equipment Surat", "- Surat Warming Devices for Hospitals"],
    ["- Surat Temperature Control Warming Systems"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient forced air warming systems in Surat, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across Surat."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of patient forced air warming systems in Surat, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe during their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient forced air warming systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and serviced, our equipment provides optimal reliability for continuous use in medical settings throughout Surat."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warming systems provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Surat are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient forced air warming systems in Surat are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient forced air warming systems are designed for seamless integration with existing medical systems in Surat. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Surat to help healthcare facilities select the right forced air warming systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our forced air warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Surat receives the highest standard of care."
    }
]









  }


  const faqData = [
    { question: "What is a Patient Forced Air Warming System?", answer: "A Patient Forced Air Warming System is a medical device that uses warm air to regulate and maintain a patient's body temperature during surgeries and medical procedures. The system circulates warm air through a specialized blanket or pad placed on the patient." },
    { question: "How does the Patient Forced Air Warming System work?", answer: "The system works by blowing warm air through a blanket that covers the patient, providing a consistent and controlled temperature to prevent hypothermia during medical procedures." },
    { question: "Is the Patient Forced Air Warming System available in Surat?", answer: "Yes, Pharmacle Health Care Private Limited offers the Patient Forced Air Warming System in Surat, ensuring healthcare facilities have access to reliable patient temperature management solutions." },
    { question: "What are the benefits of using a Patient Forced Air Warming System?", answer: "The benefits include preventing hypothermia, reducing the risk of surgical complications, enhancing patient comfort, and improving recovery times by maintaining normothermia during medical procedures." },
    { question: "How long does the Patient Forced Air Warming System maintain the patient’s temperature?", answer: "The system can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and patient safety." },
    { question: "Is the Patient Forced Air Warming System easy to use?", answer: "Yes, the system is designed to be user-friendly with simple controls, making it easy for healthcare professionals to adjust the temperature as needed during medical procedures." },
    { question: "Can the Patient Forced Air Warming System be used for different types of surgeries?", answer: "Yes, the system is versatile and can be used in a variety of surgeries and medical procedures, particularly those where controlling the patient’s body temperature is crucial." },
    { question: "Is the Patient Forced Air Warming System safe for all patients?", answer: "Yes, the system is safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating." },
    { question: "How can I purchase a Patient Forced Air Warming System in Surat?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Patient Forced Air Warming System to healthcare facilities in Surat." },
    { question: "Does Pharmacle Health Care provide support for the Patient Forced Air Warming System?", answer: "Yes, we offer full support for the Patient Forced Air Warming System, including installation, staff training, and ongoing maintenance services to ensure the system continues to perform effectively." }
  ];
  
  const testimonialsData = [
    {
      text: 'We’ve been using the Patient Forced Air Warming System from Pharmacle Health Care in our Surat hospital. It has helped us ensure that patients stay at an optimal body temperature during surgeries, improving safety and comfort.',
      name: 'Dr. Ramesh Patel',
    },
    {
      text: 'The Patient Forced Air Warming System from Pharmacle Health Care is an excellent addition to our Surat clinic. It’s easy to use, reliable, and has significantly improved patient outcomes by maintaining stable body temperature during procedures.',
      name: 'Dr. Priya Desai',
    }
  ];
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warming System in Surat",
    "description": "Explore advanced Patient Forced Air Warming Systems in Surat for effective patient temperature regulation and thermoregulation during medical treatments and surgeries. Our systems ensure patient comfort and safety in hospitals.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1354"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Forced Air Warming System in Surat | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore advanced Patient Forced Air Warming Systems in Surat for patient temperature regulation during medical treatments and surgeries. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Forced Air Warming System Surat, Surat Patient Warming Devices, Surat Forced Air Warming System, Medical Warming Equipment Surat, Patient Thermoregulation Equipment Surat, Surat Warming Devices for Hospitals, Surat Temperature Control Warming Systems"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientforcedsurat;